// 从元素树中生成Question的KeyMap
export function getQuestionKeyMap(elements) {
    let qm = {};
    let func = function (eles) {
        for (let i = 0, len = eles.length; i < len; i++) {
            if (eles[i].hasOwnProperty('question') && eles[i].question === true) {
                qm[eles[i].key] = null
            }
            if (eles[i].children && eles[i].children.length > 0) {
                func(eles[i].children)
            }
        }
    };
    func(elements);
    return qm
}

export function mergeSubmit(emptySubmit, submit) {
    if (!submit) {
        return
    }
    for (let k in submit) {
        if (emptySubmit.hasOwnProperty(k)) {
            emptySubmit[k] = submit[k]
        }
    }
}

export function parseTime(time) {
    time = time.substring(0, 19);
    time = time.replace(/-/g, '/');
    return new Date(time);
}

/**
 * 计算从开始时间到结束时间的剩余时间字符串
 * @param start unix时间戳 秒  开始时间
 * @param end unix时间戳 秒  结束时间
 * @returns {string}
 */
export function getTimeDelt(start, end) {
    // 进行中
    if (end > start) {
        let str = "";
        let left = end - start;
        let seconds = parseInt(left / 1000);
        let second = seconds % 60;
        let minutes = parseInt(seconds / 60);
        let minute = minutes % 60;
        let hours = parseInt(minutes / 60);
        let hour = hours % 24;
        let days = parseInt(hours / 24);

        if (days > 0) {
            str = days + '天';
        }
        if (hour > 0) {
            str = str + hour + '小时'
        }
        if (minute > 0) {
            str = str + minute + '分钟'
        }
        if (second > 0) {
            str = str + second + '秒'
        }
        return str;
    }
    return '0秒'
}


/**
 * 获取试题的正确答案列表
 * @param elements
 */
export function getQuestionAnswers(elements) {
    let temp = {};
    let call = function (eles) {
        if (!eles || eles.length <= 0) {
            return
        }
        for(let i = 0, len = eles.length; i < len; i ++ ) {
            if (eles[i].hasOwnProperty('question') && eles[i]['question'] && eles[i].hasOwnProperty('score')) {
                temp[eles[i].key] = {
                    score: eles[i].score,
                    answers: eles[i].answers
                };
            }
            if (eles[i].hasOwnProperty('children') && eles[i]['children']) {
                call(eles[i]['children'])
            }
        }
    };
    call(elements);
    return temp;
}

/**
 * 计算分数
 * @param answers 正确答案
 * @param submits 用户的提交
 * @return float 分值
 */
export function generateScore(answers, submits) {
    if (!answers || !submits) {
        return 0;
    }
    let score = 0.0;
    for(let key in submits) {
        if (answers.hasOwnProperty(key) && submits[key] && answers[key].answers.indexOf(submits[key]) >= 0) {
            score += parseFloat(answers[key].score);
        } else if (answers.hasOwnProperty(key) && submits[key]){
            for(let i = 0, len = answers[key].answers.length; i < len; i++) {
                if (answers[key].answers[i].replace(/([\s]{2,})/, ' ').replace(/([’])/, '\'').trim() === submits[key].replace(/([\s]{2,})/, ' ').replace(/([’])/, '\'').trim()) {
                    score += parseFloat(answers[key].score);
                    break;
                }
            }
        }
    }
    return score;
}

/**
 * 计算问题总分数
 * @param elements 元素列表
 * @return count int 问题个数
 */
export function countScore(elements) {
    let score = 0;
    let call = function (eles) {
        for (let i = 0, len = eles.length; i < len; i++) {
            if (eles[i].hasOwnProperty('question') && eles[i]['question'] === true) {
                if (eles[i].hasOwnProperty('score')) {
                    score = score + parseFloat(eles[i]['score']);
                }
            }
            if (eles[i].children && eles[i].children.length > 0) {
                call(eles[i].children)
            }
        }
    };
    call(elements);
    return score
}




















